<template>
  <div class="text-xl md:text-3xl font-bold justify-center flex py-[2vh]">
    <span class="text-gray-900">
      {{ currentText }}
    </span>
    <span
      :class="['cursor', cursorVisible ? 'opacity-100' : 'opacity-0', 'ml-1']"
      >|</span
    >
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'

// Değiştirilecek metinlerin listesi
const words = [
  'Ordino İşlemleri',
  'TIR Karnesi İşlemleri',
  'Destek ve Ek İşlemler',
  'Tüm Gümrük Çözümleri', // Genel bir toparlayıcı cümle
]

// Ayarlar
const typingSpeed = 100 // Yazma hızı (ms)
const erasingSpeed = 50 // Silme hızı (ms)
const newTextDelay = 2000 // Yeni metne geçmeden önceki bekleme süresi (ms)

// Durum değişkenleri
const currentText = ref('')
let wordIndex = 0
let charIndex = 0
let isTyping = true
let cursorInterval = null
const cursorVisible = ref(true)

// --- Metin Animasyonu Fonksiyonları ---

const type = () => {
  if (charIndex < words[wordIndex].length) {
    // Yazma işlemi
    currentText.value += words[wordIndex].charAt(charIndex)
    charIndex++
    setTimeout(type, typingSpeed)
  } else if (isTyping) {
    // Yazma bitti, silmeye başla
    isTyping = false
    setTimeout(erase, newTextDelay)
  }
}

const erase = () => {
  if (charIndex > 0) {
    // Silme işlemi
    currentText.value = words[wordIndex].substring(0, charIndex - 1)
    charIndex--
    setTimeout(erase, erasingSpeed)
  } else {
    // Silme bitti, bir sonraki kelimeye geç ve yazmaya başla
    isTyping = true
    wordIndex = (wordIndex + 1) % words.length // Döngü
    setTimeout(type, typingSpeed + 500) // Küçük bekleme
  }
}

// --- İmleç Animasyonu ---

const startCursorBlink = () => {
  cursorInterval = setInterval(() => {
    cursorVisible.value = !cursorVisible.value
  }, 500) // 500ms'de bir yanıp sönme
}

// --- Lifecycle Hooks ---

onMounted(() => {
  // Bileşen yüklendiğinde yazma işlemini başlat
  if (words.length) {
    type()
    startCursorBlink()
  }
})

onUnmounted(() => {
  // Bileşen kaldırıldığında interval'leri temizle
  if (cursorInterval) {
    clearInterval(cursorInterval)
  }
  // Diğer setTimeout'ları da temizlemek gerekebilir, ancak bu basit örnekte
  // tarayıcı sekmesi kapatıldığında otomatik temizlenecektir.
})
</script>

<style scoped>
/* Tailwind CSS 'blink' animasyonu için özel CSS */
.cursor {
  display: inline-block;
  font-family: monospace; /* İmlecin düzgün görünmesi için */
  transition: opacity 0.5s;
}
/* Tailwind'de doğrudan blink animasyonu yoksa (veya config'e eklenmediyse),
   opacity geçişi ile yanıp sönme hissi verebiliriz.
   Eğer tam bir blink isterseniz Tailwind config dosyanıza aşağıdaki
   animasyonu ekleyebilirsiniz:
   
   // tailwind.config.js
   // theme.extend.keyframes: {
   //   blink: {
   //     '0%, 100%': { opacity: '1' },
   //     '50%': { opacity: '0' },
   //   }
   // },
   // theme.extend.animation: {
   //   blink: 'blink 1s step-end infinite',
   // }
   // Sonra buraya `animate-blink` ekleyebilirsiniz.
*/
</style>
